module.exports = __webpack_public_path__ + "../static/img/pgadmin.af7fdf9e.png";